export class ListaDistribuzioneAnagrafeVO {
  id: string;
  nome: string;
  descrizione: string;
  settore: string;
  recapiti: string[];
}
